import { render, staticRenderFns } from "./center-notice.vue?vue&type=template&id=6846a298&scoped=true"
import script from "./center-notice.vue?vue&type=script&lang=js"
export * from "./center-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846a298",
  null
  
)

export default component.exports